import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import '../Pesquisar.css';
import { Button, Modal, Spin } from 'antd';
import { useConfigQuery } from '../../../../queries/useConfig';
import IdentificarConsumidor from '../FinalizarVenda/IdentificarConsumidor';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import FormClientes from './FormClientes';



const GerenciarClientes = ({ closeModal }) => {
  // validarEstoque da prop é para telas que não necessite de validação usarem como false

  const dispatch = useDispatch();
  const { data: config, error } = useConfigQuery();
  const [searchTerm, setSearchTerm] = useState('');
  const [hasSearched, setHasSearched] = useState(false);
  const [clientes, setClientes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const accessToken = window.localStorage.getItem("accessToken");
  const idUser = window.localStorage.getItem("idUser");
  const [restauranteId, setRestauranteId] = useState('');
  // currentPage representa a próxima página a ser carregada
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loja, setLoja] = useState({});

  // Refs para o container de scroll e para o elemento trigger
  const containerRef = useRef(null);
  const targetRef = useRef(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [cliente, setCliente] = useState(null);

  const handleSavedCliente = (updated) => {
    setClientes(prev =>
      prev.map(c => (c.id === updated.id ? { ...c, ...updated } : c))
    );
    setCliente(updated);        // mantém o selecionado sincronizado
    setIsModalVisible(false);
  };

  const handleOpenModal = (item) => {
    setCliente(item);
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    if (accessToken && idUser) {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      };
      axios
        .get(`https://techfood-api.herokuapp.com/v1/restaurantes/usuario/${idUser}`, options)
        .then(response => {
          setRestauranteId(response.data.id);
          setLoja(response.data);
          console.log(response.data);
        })
        .catch(error => console.error('Erro ao buscar restaurante:', error));
    }
  }, [idUser, accessToken]);

  const handleItemPress = item => {
    console.log(item);
    handleOpenModal(item);
  };

  // Função que carrega produtos a partir da página informada
  const loadClientes = useCallback(
    async (pageToLoad) => {
      if (!accessToken || !restauranteId || (!searchTerm && config?.terminalComercial?.pesquisaLivre == false)) return;
      // Se já atingiu ou ultrapassou a última página, não carrega
      if (pageToLoad >= totalPages) return;

      setIsLoading(true);
      try {
        const options = {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
          },
        };
        let response = {};
        if (searchTerm == '') {
          response = await axios.get(
            `https://techspdv-api-d3e739785e34.herokuapp.com/v1/clientes/loja/${restauranteId}?page=${pageToLoad}`,
            // `http://localhost:8077/v1/clientes/loja/${restauranteId}?page=${pageToLoad}`,
            options
          );

        } else {
          response = await axios.get(
            `https://techspdv-api-d3e739785e34.herokuapp.com/v1/clientes/loja/${restauranteId}/buscarporLojaDocumentoEmailNomeTelefone/${searchTerm}?page=${pageToLoad}`,

            ///v1/clientes/loja/9885304c-bcc3-4772-ae5c-a54e63f29f56/buscarporLojaDocumentoEmailNomeTelefone/40700660801
            options
          );

        }

        const produtos = response.data._embedded?.clientes || [];
        const { number, totalPages: total } = response.data.page;
        setTotalPages(total);

        if (pageToLoad === 0) {
          // Primeira página: substitui os produtos
          setClientes(produtos);
        } else {
          // Páginas seguintes: anexa os novos produtos
          setClientes(prev => [...prev, ...produtos]);
        }

        // Atualiza para a próxima página
        const nextPage = number + 1;
        setCurrentPage(nextPage);
      } catch (error) {
        console.error('Erro ao carregar produtos:', error);
      } finally {
        setIsLoading(false);
      }
    },
    [accessToken, restauranteId, searchTerm, totalPages]
  );

  // Acionado ao clicar no botão "Pesquisar"
  const handleSearch = () => {
    // Reinicia os estados para nova pesquisa
    setClientes([]);
    setCurrentPage(0);
    setTotalPages(1);
    setHasSearched(true);
    loadClientes(0);
  };

  // Intersection Observer para carregar páginas extras quando o fim do container for alcançado
  useEffect(() => {
    // Só ativa se já houve uma pesquisa
    if (!hasSearched || !containerRef.current) return;

    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting && !isLoading && currentPage < totalPages) {
          loadClientes(currentPage);
        }
      },
      { root: containerRef.current, threshold: 0.1 }
    );

    if (targetRef.current) {
      observer.observe(targetRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [hasSearched, isLoading, currentPage, totalPages, loadClientes]);

    const formatarTelefone = (phoneNumber) => {
    const cleaned = phoneNumber.replace(/\D/g, '');
    if (cleaned.startsWith('55') && (cleaned.length === 12 || cleaned.length === 13)) {
      const numberWithoutCountryCode = cleaned.substring(2);
      if (numberWithoutCountryCode.length === 11) {
        return numberWithoutCountryCode.replace(/^(\d{2})(\d{5})(\d{4})$/, '+55 ($1) $2-$3');
      } else if (numberWithoutCountryCode.length === 10) {
        return numberWithoutCountryCode.replace(/^(\d{2})(\d{4})(\d{4})$/, '+55 ($1) $2-$3');
      } else {
        return phoneNumber;
      }
    } else {
      return phoneNumber;
    }
  };
  function formatarCpfCnpj(cpfCnpj) {
    cpfCnpj = cpfCnpj.replace(/\D/g, '');

    if (cpfCnpj.length === 11) {
      return cpfCnpj.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else if (cpfCnpj.length === 14) {
      return cpfCnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    } else {
      return cpfCnpj;
    }
  }


  const renderItem = item => {
    return (
      <div
        className="card"
        onClick={() => { handleItemPress(item) }}
        style={{ position: 'relative' }}
      >
        <span className="card-text">{item.nomeCompleto}</span>
        <br />
        <span className="card-text-ean">{formatarCpfCnpj(item?.documentoCpfCnpj)}</span>
        <br />
        <span className="card-text">{formatarTelefone(item?.telefone)}</span>
        <br />
        <span className="card-text">{item.email}</span>
      </div>
    );
  };

  return (
    <div className="container-pesquisar">
      <div className="modal-header">
        <Button
          type="primary"
          onClick={() => handleOpenModal(true)}
          style={{ backgroundColor: "black", borderColor: "black" }}
        >
          <span>Novo</span>
        </Button>
        <h2>Clientes</h2>

      </div>

      <div className="search-container">
        <input
          className="input"
          type="text"
          placeholder="Pesquisar por Nome, E-mail, Documento ou Telefone"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
        />

        <button
          className="search-button"
          disabled={!accessToken || !restauranteId || (!searchTerm && config?.terminalComercial?.pesquisaLivre == false)}
          onClick={handleSearch}
        >
          Pesquisar
        </button>
      </div>

      {isLoading && clientes.length === 0 ? (
        <Spin
          spinning={isLoading}
          tip={<span style={{ fontSize: 16, fontWeight: '500', color: '#333' }}>Carregando...</span>}
          size="large"
        />

      ) : (
        <div className="scroll-container" ref={containerRef}>
          <div className="product-list">
            {clientes.length > 0 ? (
              clientes.map(cliente => (
                <React.Fragment key={cliente.id}>{renderItem(cliente)}</React.Fragment>
              ))
            ) : (
              <p className="empty-list-text">Nenhum cliente encontrado</p>
            )}
          </div>
          {isLoading && <div className="loading">Carregando...</div>}
          {/* Elemento trigger para o Intersection Observer */}
          <div ref={targetRef} id="scroll-end" style={{ height: '10px' }}></div>
        </div>
      )}



      <Modal
        visible={isModalVisible}
        onCancel={handleCloseModal}
        footer={null}
        width="100vw"
        bodyStyle={{ padding: 0 }}
        centered
        closeIcon={null} // Remove o ícone de fechamento padrão
        destroyOnClose={true}
      >

        <Button
          type="primary"
          onClick={handleCloseModal}
          style={{ backgroundColor: "black", borderColor: "black" }}
        >
          <span>Abandonar <FontAwesomeIcon icon={faSignOutAlt} /></span>
        </Button>

        <FormClientes onClose={handleCloseModal} onSaved={handleSavedCliente} cliente={cliente} setCliente={setCliente}></FormClientes>
      </Modal>
    </div>
  );
};

export default GerenciarClientes;
